import React from "react";

type FormErrors = {
  affiliationType: boolean;
  affiliationSource: boolean;
  affiliationActivity: boolean;
  url: boolean;
  imageUrl: boolean;
  text: boolean;
  ratings: boolean;
  date: boolean;
  submissionTried: boolean;
};

type Props = {
  errors: FormErrors;
  showError: boolean;
  successAffiliation: boolean;
  affiliationCreationError: unknown;
  updateAffiliationError: unknown;
};

const AffiliationFormErrors = ({
  errors,
  showError,
  successAffiliation,
  affiliationCreationError,
  updateAffiliationError,
}: Props) => {
  if (!showError) {
    return null;
  }

  return (
    <div className="p-4 my-4 bg-red-200 text-gray-800 rounded-lg">
      <ul>
        {errors.affiliationType && (
          <li>Affiliation Type is a required field.</li>
        )}
        {errors.affiliationSource && (
          <li>Affiliation Source is a required field.</li>
        )}
        {errors.affiliationActivity && (
          <li>Affiliation Activity is a required field.</li>
        )}
        {errors.url && (
          <li>Content Link is a required field and should have valid URL.</li>
        )}
        {errors.text && <li>Description is a required field.</li>}
        {errors.date && <li>Date is a required field.</li>}
        {errors.imageUrl && <li>ImageURL is not a valid URL.</li>}
        {errors.ratings && <li>At least one behavior should be selected.</li>}
        {!successAffiliation &&
          (!!affiliationCreationError || !!updateAffiliationError) && (
            <li>
              Error saving affiliation, please try again or contact support.
            </li>
          )}
      </ul>
    </div>
  );
};

export default AffiliationFormErrors;
